export const FEATURE_FLAG_KEYS = [
  "saved_searches",
  "ninhadas",
  "admin_pipeline",
  "videos",
  "shelter_pro",
  "paid_tiers",
  "first_saved_search_nudge",
  "new_matches_pawmatch",
  "missing_chip_tasks",
  "courses",
] as const
export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number]

// Each state includes the audience of the one before it (ADMINS also covers testers).
export const FEATURE_FLAG_STATES = ["OFF", "TESTERS", "ADMINS", "ALL"] as const
export type FeatureFlagState = (typeof FEATURE_FLAG_STATES)[number]

export type FeatureFlagMap = Record<FeatureFlagKey, boolean>

export interface FeatureFlagDefinition {
  label: string
  description: string
}

export const FEATURE_FLAG_DEFINITIONS: Record<FeatureFlagKey, FeatureFlagDefinition> = {
  saved_searches: {
    label: "Pesquisas guardadas",
    description:
      "Botão de guardar pesquisa, secção nas definições e alertas (in-app, push e email) de novos animais.",
  },
  ninhadas: {
    label: "Ninhadas",
    description:
      "Cartões e páginas públicas de ninhadas e criação/edição de ninhadas no painel. Desligado esconde também os animais membros.",
  },
  admin_pipeline: {
    label: "Pipeline de adoção",
    description:
      "Formulários, candidaturas, mensagens, lembretes, definições e plano do abrigo, denúncias e central de dúvidas (frontend e API).",
  },
  videos: {
    label: "Vídeos de animais",
    description: "Upload e gestão de vídeos no formulário de animais do painel (funcionalidade Pro).",
  },
  shelter_pro: {
    label: "Planos de abrigo",
    description: "Secção \"Plano atual\" no separador Abrigo e funcionalidades Pro nas definições do abrigo (lembretes personalizados, mensagens).",
  },
  paid_tiers: {
    label: "Planos pagos (utilizadores)",
    description:
      "Página /planos e sugestões de upgrade no PawMatch. Nunca aparece nas apps nativas (sem compras in-app).",
  },
  first_saved_search_nudge: {
    label: "Lembrete: primeira pesquisa guardada",
    description: "Notificação agendada a sugerir guardar uma pesquisa. Requer também Pesquisas guardadas.",
  },
  new_matches_pawmatch: {
    label: "Alertas de novos matches PawMatch",
    description: "Notificação agendada de novos animais que combinam com as preferências PawMatch.",
  },
  missing_chip_tasks: {
    label: "Tarefas de animais sem chip",
    description: "Notificação agendada aos abrigos com animais sem número de chip.",
  },
  courses: {
    label: "Cursos e Formulário de Adoção Pawseum",
    description:
      "Curso do Adotante, Formação de Anunciante, Formulário de Adoção Pawseum, candidaturas de Particulares, Readiness Band e revisão de conteúdo (piloto: os admins de abrigo revisores têm de estar na lista de testers), incluindo os bloqueios no servidor, só para quem tem a funcionalidade. Desligado: Particulares continuam só por email. Ordem para ALL: build nas lojas -> subir MIN_IOS_BUILD/MIN_ANDROID_BUILD -> ALL.",
  },
}

export const ALL_FEATURES_OFF: FeatureFlagMap = Object.fromEntries(
  FEATURE_FLAG_KEYS.map((key) => [key, false]),
) as FeatureFlagMap

export function isFeatureFlagKey(value: unknown): value is FeatureFlagKey {
  return typeof value === "string" && (FEATURE_FLAG_KEYS as readonly string[]).includes(value)
}

export function isFeatureFlagState(value: unknown): value is FeatureFlagState {
  return typeof value === "string" && (FEATURE_FLAG_STATES as readonly string[]).includes(value)
}
